import { render, staticRenderFns } from "./IconPhoneRing.vue?vue&type=template&id=2e80f891&"
import script from "./IconPhoneRing.vue?vue&type=script&lang=ts&"
export * from "./IconPhoneRing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports